import React from "react";
import { Building2, Landmark, Briefcase, ShieldCheck, Scale } from "lucide-react";
import "./style.css";

const brandsData = [
	{ name: "Moonface Techs", icon: Briefcase },
	{ name: "Hendless Properties", icon: Building2 },
	{ name: "Seoka Bottle Store", icon: Landmark },
	{ name: "Mpai Corp", icon: ShieldCheck },
	{ name: "Moses Rubble Removers", icon: Scale },
	{ name: "Mmalejoe Holdings", icon: ShieldCheck },
	{ name: "Luline Facilities", icon: Briefcase },
    { name: "Pabasa Advocates", icon: Briefcase },
];

const TrustedBy = () => {
	return (
		<section className="trusted-by-section">
			<div className="trusted-by-container">
				<p className="trusted-by-title">
					TRUSTED BY INDUSTRY LEADING COMPANIES & ORGANISATIONS
				</p>

				<div className="trusted-by-grid">
					{brandsData.map((brand, index) => {
						const IconComponent = brand.icon;
						return (
							<div className="brand-item" key={index}>
								<IconComponent size={28} className="brand-icon" />
								<span className="brand-name">{brand.name}</span>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default TrustedBy;